module.exports = __webpack_public_path__ + "static/media/1019680.2833f079.jpg";